// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 982) return "static/chunks/982.fb19c90db6f70d20.js";
	if (chunkId === 306) return "static/chunks/306.8e948ed99a3dcd77.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"92":"f0b9ada21535cc2e","360":"dd23cff0a04f13b6","431":"29564a12b8cca8e4","939":"163c022470a9e51a"}[chunkId] + ".js";
};